import React, { Component } from "react";

class IconMailStroke extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <svg
                version="1.1"
                x="0px"
                y="0px"
                width="45.5px"
                height="45.7px"
                viewBox="0 0 45.5 45.7"
                preserveAspectRatio="xMinYMin meet"
                role="presentation"
            >
                <polyline fill="none" points="45,18.5 45,45.2 0.5,45.2 0.5,18.5 " />
                <polyline fill="none" points="0.5,18.5 22.8,36.5 45,18.5 " />
                <polyline fill="none" points="45,18.5 22.8,0.5 0.5,18.5 " />
                <line fill="none" x1="17.4" y1="32.1" x2="0.5" y2="45.2" />
                <line fill="none" x1="45" y1="45.2" x2="28.5" y2="31.8" />
            </svg>
        );
    }
}

export default IconMailStroke;
